export const qr = {
  hero: {
    title: {
      pt1: 'A',
      pt2: 'custom QR solution',
      pt3: 'crafted for your restaurant'
    },
    description: 'Bistroo\'s QR solutions facilitates a cost-effective table ordering process, relieving your staff members and enhancing customer satisfaction from the first scan to the check-out. ',
    button: 'Explore QR-manager'
  },
  paragraphs: {
    paragraph_1: {
      title: 'Simplify ordering, maximize satisfaction',
      text: 'Provide your customer with the freedom to order whatever and whenever they want. Optimize service, elevate ease, and boost customer satisfaction one scan at a time. ',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_2: {
      title: 'Update your QR-shop with ease',
      text: 'Any updates in the Bistroo manager are instantly synced to the QR-stickers on your tables, making menu changes quicker and easier than ever. ',
      cta: ''
    },
    paragraph_3: {
      title: 'Your style, your stickers',
      text: 'The high-quality stickers are custom made in your style & branding. Made from durable and weather resistant material, the stickers are suited for both indoor and outdoor use.  ',
      cta: 'Explore the Bistroo packages'
    },
    paragraph_4: {
      title: 'No touch administration',
      text: 'From payments to invoices, everything is fully automated. Orders are processed, payments can be tracked and invoices are generated automatically, minimizing your workload drastically. ',
      cta: ''
    }
  },
  key_features: {
    cards: {
      card_1: {
        title: 'Make upselling a core part of your business.',
        text: 'Utilize the smart upselling options and turn them into a natural part of every on-location order - growing revenue with ease.',
        button: '',
        img_alt: ''
      },
      card_2: {
        title: 'Integrations.',
        text: 'Connect your preferred POS-system, or accountancy software.',
        button: '',
        img_alt: ''
      },
      card_3: {
        title: 'Solve any workforce challenges.',
        text: 'If a workforce challenge arises, you can easily keep up by allowing for QR-tabletop ordering.',
        button: '',
        img_alt: ''
      },
      card_4: {
        title: 'Instant payments.',
        text: 'No more paying at the counter, customers pay while ordering.',
        button: '',
        img_alt: ''
      },
      card_5: {
        title: 'Discounts and Loyalty.',
        text: 'Encourage customer to use the QR-solutions by using our discount and loyalty options.',
        button: '',
        img_alt: ''
      }
    }
  },
  testimonial: {
    text: '“A great collaboration and a partner that is there for you 24/7.”',
    cta: 'Read De Wethouder\'s story',
    name: 'De wethouder',
    job_title: 'Sushi & drink Club'
  }
}